<template>
	<div class="main">
		<div class="product">
            <div class="pro"><router-link :to="{path:'/'}" class="link"><span >{{$t('nav.home')}} > </span></router-link><router-link :to="{path:'/product/product'}" class="link"><span >{{$t('nav.pro')}}</span></router-link></div>
			<div class="h_title">
                <el-image src="./static/image/tleft.png" fit="contain"></el-image>{{$t('nav.pro')}}
                <el-image src="./static/image/tright.png" fit="contain"></el-image>
		    </div>
            <div class="pro_list">
                 <el-table :data="tableData" stripe style="width: 100%">
                    <el-table-column prop="cas" :label="$t('pro.cash')" width="240">
                           
					</el-table-column>
                    <el-table-column prop="scope" :label="$t('pro.zname')" width="240">
						<template slot-scope="scope">
								<span v-if="$i18n.locale == 'zh'">{{scope.row.name}}</span>
								<span v-if="$i18n.locale == 'en'">{{scope.row.y_name}}</span>
								<span v-else>{{scope.row.e_name}}</span>

						</template>
					</el-table-column>
                    <el-table-column prop="formula" :label="$t('pro.fzs')" width="240">
						<template slot-scope="scope">
						   <span v-html="scope.row.formula"></span>
						</template>
					</el-table-column>
                    <el-table-column prop="scope" :label="$t('pro.jgs')" width="240">
						<template slot-scope="scope">
						<el-image :src='scope.row.image_one' fit="contain"></el-image>
						</template>
					</el-table-column>
                    <el-table-column prop="scope" label="" width="240">
						<template slot-scope="scope">
							<!-- $router.go(0) -->
							<span class="mores" @click="$router.push({ path: '/product/prodetail?id='+ scope.row.id+ '&name='+$route.query.name});">
								{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image></span>
						</template>
					</el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage4"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="count"
                >
                </el-pagination>
            </div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
                tableData:[],
                currentPage4:1,
				count:0,
				page:1,
				limit:10,
				total:0,
			}
		},
		mounted() {
			this.getPor()
		},
		methods: {
            // 当前页数
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.page = val;
                this.handData();
            },
			 getPor() {
				var that = this;
				this.$axios
					.post("/api/index/search", {
					   keyword:this.$route.query.keyword,
					   page:this.page,
					   limit:this.limit
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.tableData = ret.data.data.product;
							that.count=ret.data.data.count
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
        }
	}
</script>

<style lang="scss" scoped>
	.main {
		background-color: #FFFFFF;
		width: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;

		.introduce {
			width: 1200px;
			height: 433px;
			margin: 60px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.ad {
				width: 800px;
				height: 433px;
			}

			.info {
				width: 800px;
				height: 433px;
				padding-left: 40px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title {
					font-size: 30px;
					color: #004098;
					font-weight: bold;
				}

				span {
					display: block;
					width: 40px;
					height: 4px;
					background: #004098;
					margin-top: 20px;
				}

				.cro {
					font-size: 18px;
					color: #333;
					margin: 20px 0;
				}

				.text {
					height: 300px;

					p {
						font-size: 16px;
						color: #999;
						text-indent: 2em;
					}

				}
				.link {
					font-size: 16px;
					color: #004098;
					display: flex;
					align-items: center;
					cursor: pointer;

					.el-image {
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}
			}
			.info2 {
				background-color: #F7F8FA;
				padding: 50px 40px;
			}
		}
		.h_title {
			font-size: 30px;
			color: #004098;
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 1200px;
			padding: 40px 0;
			font-weight: bold;

			.el-image {
				width: 515px;
				height: 13px;
			}
		}

		.range {
			width: 1200px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.li {
				font-size: 16px;
				color: #333;
				display: flex;
				align-items: center;
				flex-direction: column;

				.el-image {
					width: 70px;
					height: 70px;
					padding: 15px;
					margin-bottom: 15px;
					background-color: #004098;
				}
			}
		}

		.el-carousel {
			width: 1200px;
		}

		.product {
			width: 100%;
			background-color: #F7F8FA;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-bottom: 60px;

			.list {
				width: 1200px;
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
                flex-wrap:wrap;
				.shop {
					width: 390px;
					height: 400px;
					background: #FFFFFF;
					padding: 20px;
					display: flex;
					flex-direction: column;
                    margin-bottom: 20px;
					.el-image {
						width: 350px;
						height: 260px;
					}
					.title {
						font-size: 20px;
						color: #333;
						margin: 15px 0;
					}

					.text {
						font-size: 16px;
						color: #666;
					}

					.link {
						font-size: 16px;
						color: #004098;
						display: flex;
						align-items: center;
						cursor: pointer;
						margin-top: 10px;

						.el-image {
							width: 16px;
							height: 16px;
							margin-left: 5px;
						}
					}
				}
			}
		}
        .pro{
            width: 1200px;
            line-height:30px;
            margin:40px 0 0;
            overflow: hidden;
            text-align: left;
        }	
        .pro_list{
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
        }
        .page{
            width: 1200px;
            text-align: right;
            overflow: hidden;
            margin:40px 0;
        }
			.mores{
			line-height: 40px;
		}
		.mores .el-image{
			width: 20px;
			height: 20px;
			margin-top: 5px;
			vertical-align: -3px;
			margin-left: 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/search/search.vue